import {useEffect, useState} from 'react';
import {downloadVttResourceUrl, listVttResources} from './record/vttResourcesApi';
import {parseVttChapters} from '../utils/vttParser';
import {chapterLanguage} from '../utils/chapterLanguage';

const emptyChapters = {};

const useChapterCues = (identifier, refresh = 0) => {
    const [stored, setStored] = useState(null);

    useEffect(() => {
        let active = true;
        if (!identifier) return undefined;

        const load = async () => {
            try {
                const response = await listVttResources(identifier, 'chapter');
                if (!response.ok) throw new Error('Could not load chapters');
                const items = await response.json();
                const entries = await Promise.all((Array.isArray(items) ? items : []).map(async item => {
                    if (!item?.language) return null;
                    try {
                        const resource = await fetch(downloadVttResourceUrl(identifier, 'chapter', item.language));
                        if (!resource.ok) return null;
                        return [chapterLanguage(item.language), parseVttChapters(await resource.text())];
                    } catch {
                        return null;
                    }
                }));
                if (active) setStored({identifier, refresh, chapters: Object.fromEntries(entries.filter(Boolean))});
            } catch {
                if (active) setStored({identifier, refresh, chapters: emptyChapters});
            }
        };

        load();
        return () => {
            active = false;
        };
    }, [identifier, refresh]);

    return stored?.identifier === identifier && stored?.refresh === refresh ? stored.chapters : emptyChapters;
};

export default useChapterCues;